import React from 'react';
import NavigationHeader from '../components/NavigationHeader';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';

const privacyContent = {
  en: {
    title: 'Privacy Policy',
    lastUpdated: 'January 2023',
    sections: [
      {
        title: '1. Data Controller',
        content: `This Privacy Policy is intended to inform visitors to Our Website (www.ertheo.com) and clients of the Company about the collection, use and disclosure of personal data when using our services and the options available to you regarding your information.

The data controller for your data is ERTHEO LIMITED, with Company Number 14272961. 

Our registered office is at SUITE 140 TEMPLE CHAMBERS, 3-7 TEMPLE AVENUE, LONDON, ENGLAND EC4Y 0DA.

Email address – info@ertheo.com`
      },
      {
        title: '2. Information We Collect',
        content: `We collect several different types of information for various purposes to provide and improve our service to you.

Personal Data:
While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to:
• Email address
• First name and last name
• Phone number
• Address, State, Province, ZIP/Postal code, City
• Cookies and Usage Data
• Date of birth (for minors attending camps)
• Medical information (allergies, conditions, medications)
• Emergency contact information
• Passport/ID information for travel purposes

Usage Data:
We may also collect information about how the service is accessed and used. This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

Tracking & Cookies Data:
We use cookies and similar tracking technologies to track the activity on our service and hold certain information. Cookies are files with small amounts of data which may include an anonymous unique identifier.`
      },
      {
        title: '3. Use of Data',
        content: `The Company uses the collected data for various purposes:

• To provide and maintain the service
• To notify you about changes to our service
• To allow you to participate in interactive features of our service when you choose to do so
• To provide customer care and support
• To provide analysis or valuable information so that we can improve the service
• To monitor the usage of the service
• To detect, prevent and address technical issues
• To process your registration for camps and programs
• To communicate with you regarding your booking
• To send you information about our programs and services (with your consent)
• To comply with legal obligations`
      },
      {
        title: '4. Legal Basis for Processing Personal Data',
        content: `Our legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Data we collect and the specific context in which we collect it.

The Company may process your Personal Data because:
• We need to perform a contract with you (processing your camp registration)
• You have given us permission to do so
• The processing is in our legitimate interests and it's not overridden by your rights
• To comply with the law`
      },
      {
        title: '5. Retention of Data',
        content: `The Company will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.

The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our service, or we are legally obligated to retain this data for longer time periods.

After a booking or inquiry is completed, we typically retain personal data for up to 7 years for legal and accounting purposes.`
      },
      {
        title: '6. Transfer of Data',
        content: `Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.

If you are located outside United Kingdom and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United Kingdom and process it there.

Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

The Company will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.`
      },
      {
        title: '7. Disclosure of Data',
        content: `The Company may disclose your Personal Data in the good faith belief that such action is necessary to:
• To comply with a legal obligation
• To protect and defend the rights or property of the Company
• To prevent or investigate possible wrongdoing in connection with the service
• To protect the personal safety of users of the service or the public
• To protect against legal liability

We may also share your data with:
• Partner Organizations (schools, camps, sports academies) that provide the services you have booked
• Payment processors to complete transactions
• Legal and regulatory authorities when required by law`
      },
      {
        title: '8. Security of Data',
        content: `The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

We implement appropriate technical and organizational measures to protect personal data against unauthorized or unlawful processing, accidental loss, destruction or damage.

These measures include:
• Encryption of data in transit (SSL/TLS)
• Secure servers and databases
• Access controls and authentication
• Regular security assessments
• Staff training on data protection`
      },
      {
        title: '9. Your Data Protection Rights Under General Data Protection Regulation (GDPR)',
        content: `If you are a resident of the European Economic Area (EEA), you have certain data protection rights.

The Company aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.

You have the following data protection rights:
• The right to access – You have the right to request copies of your personal data.
• The right to rectification – You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete.
• The right to erasure – You have the right to request that we erase your personal data, under certain conditions.
• The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.
• The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.
• The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.

If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us at info@ertheo.com.

Please note that we may ask you to verify your identity before responding to such requests.

You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).`
      },
      {
        title: '10. Service Providers',
        content: `We may employ third party companies and individuals to facilitate our service ("Service Providers"), to provide the service on our behalf, to perform service-related services or to assist us in analyzing how our service is used.

These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.

Service providers include:
• Website hosting providers
• Payment processors
• Email service providers
• Analytics providers
• Partner Organizations (camps, schools, academies)`
      },
      {
        title: '11. Links to Other Sites',
        content: `Our service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.

We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.`
      },
      {
        title: '12. Children\'s Privacy',
        content: `Our services are designed to be booked by parents or guardians on behalf of minors. We do not knowingly collect personally identifiable information directly from anyone under the age of 18 without parental consent.

When parents or guardians register a minor for a camp, they provide the minor's personal information on their behalf. This information is used solely for the purpose of providing the camp services and ensuring the safety and wellbeing of the participant.

If you are a parent or guardian and you are aware that your child has provided us with Personal Data without your consent, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.`
      },
      {
        title: '13. Changes to This Privacy Policy',
        content: `We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.

We will let you know via email and/or a prominent notice on our service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.

You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.`
      },
      {
        title: '14. Contact Us',
        content: `If you have any questions about this Privacy Policy, please contact us:

By email: info@ertheo.com

By mail:
ERTHEO LIMITED
SUITE 140 TEMPLE CHAMBERS
3-7 TEMPLE AVENUE
LONDON, ENGLAND EC4Y 0DA`
      }
    ]
  },
  es: {
    title: 'Política de Privacidad',
    lastUpdated: 'Enero 2023',
    sections: [
      {
        title: '1. Responsable del Tratamiento',
        content: `Esta Política de Privacidad tiene como objetivo informar a los visitantes de nuestro sitio web (www.ertheo.com) y a los clientes de la Compañía sobre la recopilación, uso y divulgación de datos personales al utilizar nuestros servicios y las opciones disponibles con respecto a su información.

El responsable del tratamiento de sus datos es ERTHEO LIMITED, con número de empresa 14272961.

Nuestra sede registrada está en SUITE 140 TEMPLE CHAMBERS, 3-7 TEMPLE AVENUE, LONDON, ENGLAND EC4Y 0DA.

Correo electrónico – info@ertheo.com`
      },
      {
        title: '2. Información que Recopilamos',
        content: `Recopilamos varios tipos diferentes de información para diversos propósitos con el fin de proporcionar y mejorar nuestro servicio.

Datos Personales:
Al utilizar nuestro servicio, podemos solicitarle que nos proporcione cierta información de identificación personal que puede usarse para contactarlo o identificarlo. La información de identificación personal puede incluir, entre otros:
• Dirección de correo electrónico
• Nombre y apellidos
• Número de teléfono
• Dirección, Estado, Provincia, Código Postal, Ciudad
• Cookies y Datos de Uso
• Fecha de nacimiento (para menores que asisten a campamentos)
• Información médica (alergias, condiciones, medicamentos)
• Información de contacto de emergencia
• Información de pasaporte/identificación para fines de viaje

Datos de Uso:
También podemos recopilar información sobre cómo se accede y utiliza el servicio. Estos Datos de Uso pueden incluir información como la dirección de Protocolo de Internet de su ordenador (por ejemplo, dirección IP), tipo de navegador, versión del navegador, las páginas de nuestro servicio que visita, la hora y fecha de su visita, el tiempo dedicado a esas páginas, identificadores únicos de dispositivos y otros datos de diagnóstico.

Datos de Seguimiento y Cookies:
Utilizamos cookies y tecnologías de seguimiento similares para rastrear la actividad en nuestro servicio y mantener cierta información.`
      },
      {
        title: '3. Uso de los Datos',
        content: `La Compañía utiliza los datos recopilados para diversos propósitos:

• Proporcionar y mantener el servicio
• Notificarle sobre cambios en nuestro servicio
• Permitirle participar en funciones interactivas de nuestro servicio cuando elija hacerlo
• Proporcionar atención y soporte al cliente
• Proporcionar análisis o información valiosa para que podamos mejorar el servicio
• Supervisar el uso del servicio
• Detectar, prevenir y abordar problemas técnicos
• Procesar su inscripción en campamentos y programas
• Comunicarnos con usted sobre su reserva
• Enviarle información sobre nuestros programas y servicios (con su consentimiento)
• Cumplir con las obligaciones legales`
      },
      {
        title: '4. Base Legal para el Tratamiento de Datos Personales',
        content: `Nuestra base legal para recopilar y utilizar la información personal descrita en esta Política de Privacidad depende de los Datos Personales que recopilamos y el contexto específico en el que los recopilamos.

La Compañía puede procesar sus Datos Personales porque:
• Necesitamos ejecutar un contrato con usted (procesar su inscripción al campamento)
• Nos ha dado permiso para hacerlo
• El procesamiento está en nuestros intereses legítimos y no está anulado por sus derechos
• Para cumplir con la ley`
      },
      {
        title: '5. Retención de Datos',
        content: `La Compañía retendrá sus Datos Personales solo durante el tiempo que sea necesario para los fines establecidos en esta Política de Privacidad. Retendremos y utilizaremos sus Datos Personales en la medida necesaria para cumplir con nuestras obligaciones legales, resolver disputas y hacer cumplir nuestros acuerdos y políticas legales.

La Compañía también retendrá los Datos de Uso para propósitos de análisis interno. Los Datos de Uso generalmente se retienen por un período de tiempo más corto, excepto cuando estos datos se utilizan para fortalecer la seguridad o para mejorar la funcionalidad de nuestro servicio, o estamos legalmente obligados a retener estos datos por períodos de tiempo más largos.

Después de completar una reserva o consulta, normalmente retenemos los datos personales hasta 7 años para fines legales y contables.`
      },
      {
        title: '6. Transferencia de Datos',
        content: `Su información, incluidos los Datos Personales, puede ser transferida a — y mantenida en — ordenadores ubicados fuera de su estado, provincia, país u otra jurisdicción gubernamental donde las leyes de protección de datos pueden diferir de las de su jurisdicción.

Si se encuentra fuera del Reino Unido y elige proporcionarnos información, tenga en cuenta que transferimos los datos, incluidos los Datos Personales, al Reino Unido y los procesamos allí.

Su consentimiento a esta Política de Privacidad seguido de su envío de dicha información representa su acuerdo con esa transferencia.

La Compañía tomará todas las medidas razonablemente necesarias para garantizar que sus datos sean tratados de forma segura y de acuerdo con esta Política de Privacidad.`
      },
      {
        title: '7. Divulgación de Datos',
        content: `La Compañía puede divulgar sus Datos Personales de buena fe creyendo que dicha acción es necesaria para:
• Cumplir con una obligación legal
• Proteger y defender los derechos o propiedad de la Compañía
• Prevenir o investigar posibles irregularidades en conexión con el servicio
• Proteger la seguridad personal de los usuarios del servicio o del público
• Proteger contra responsabilidad legal

También podemos compartir sus datos con:
• Organizaciones Asociadas (escuelas, campamentos, academias deportivas) que proporcionan los servicios que ha reservado
• Procesadores de pago para completar transacciones
• Autoridades legales y regulatorias cuando lo exija la ley`
      },
      {
        title: '8. Seguridad de los Datos',
        content: `La seguridad de sus datos es importante para nosotros, pero recuerde que ningún método de transmisión por Internet, o método de almacenamiento electrónico es 100% seguro. Si bien nos esforzamos por utilizar medios comercialmente aceptables para proteger sus Datos Personales, no podemos garantizar su seguridad absoluta.

Implementamos medidas técnicas y organizativas apropiadas para proteger los datos personales contra el procesamiento no autorizado o ilegal, pérdida accidental, destrucción o daño.

Estas medidas incluyen:
• Cifrado de datos en tránsito (SSL/TLS)
• Servidores y bases de datos seguros
• Controles de acceso y autenticación
• Evaluaciones de seguridad regulares
• Capacitación del personal en protección de datos`
      },
      {
        title: '9. Sus Derechos de Protección de Datos bajo el RGPD',
        content: `Si es residente del Espacio Económico Europeo (EEE), tiene ciertos derechos de protección de datos.

La Compañía tiene como objetivo tomar medidas razonables para permitirle corregir, modificar, eliminar o limitar el uso de sus Datos Personales.

Tiene los siguientes derechos de protección de datos:
• El derecho de acceso – Tiene derecho a solicitar copias de sus datos personales.
• El derecho de rectificación – Tiene derecho a solicitar que corrijamos cualquier información que crea que es inexacta o que completemos la información que crea que está incompleta.
• El derecho de supresión – Tiene derecho a solicitar que eliminemos sus datos personales, bajo ciertas condiciones.
• El derecho a restringir el procesamiento – Tiene derecho a solicitar que restrinjamos el procesamiento de sus datos personales, bajo ciertas condiciones.
• El derecho de oposición al procesamiento – Tiene derecho a oponerse a nuestro procesamiento de sus datos personales, bajo ciertas condiciones.
• El derecho a la portabilidad de datos – Tiene derecho a solicitar que transfiramos los datos que hemos recopilado a otra organización, o directamente a usted, bajo ciertas condiciones.

Si desea saber qué Datos Personales tenemos sobre usted y si desea que se eliminen de nuestros sistemas, contáctenos en info@ertheo.com.

Tiene derecho a presentar una queja ante una Autoridad de Protección de Datos sobre nuestra recopilación y uso de sus Datos Personales.`
      },
      {
        title: '10. Proveedores de Servicios',
        content: `Podemos emplear empresas e individuos de terceros para facilitar nuestro servicio ("Proveedores de Servicios"), para proporcionar el servicio en nuestro nombre, para realizar servicios relacionados con el servicio o para ayudarnos a analizar cómo se utiliza nuestro servicio.

Estos terceros tienen acceso a sus Datos Personales solo para realizar estas tareas en nuestro nombre y están obligados a no divulgarlos ni utilizarlos para ningún otro propósito.

Los proveedores de servicios incluyen:
• Proveedores de alojamiento web
• Procesadores de pago
• Proveedores de servicios de correo electrónico
• Proveedores de análisis
• Organizaciones Asociadas (campamentos, escuelas, academias)`
      },
      {
        title: '11. Enlaces a Otros Sitios',
        content: `Nuestro servicio puede contener enlaces a otros sitios que no son operados por nosotros. Si hace clic en un enlace de terceros, será dirigido al sitio de ese tercero. Le recomendamos encarecidamente que revise la Política de Privacidad de cada sitio que visite.

No tenemos control sobre y no asumimos ninguna responsabilidad por el contenido, las políticas de privacidad o las prácticas de sitios o servicios de terceros.`
      },
      {
        title: '12. Privacidad de los Menores',
        content: `Nuestros servicios están diseñados para ser reservados por padres o tutores en nombre de menores. No recopilamos conscientemente información de identificación personal directamente de menores de 18 años sin el consentimiento de los padres.

Cuando los padres o tutores registran a un menor para un campamento, proporcionan la información personal del menor en su nombre. Esta información se utiliza únicamente con el propósito de proporcionar los servicios del campamento y garantizar la seguridad y el bienestar del participante.

Si es padre o tutor y sabe que su hijo nos ha proporcionado Datos Personales sin su consentimiento, contáctenos.`
      },
      {
        title: '13. Cambios en Esta Política de Privacidad',
        content: `Podemos actualizar nuestra Política de Privacidad de vez en cuando. Le notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página.

Le informaremos por correo electrónico y/o un aviso destacado en nuestro servicio, antes de que el cambio entre en vigencia y actualizaremos la "fecha de vigencia" en la parte superior de esta Política de Privacidad.

Se le aconseja revisar esta Política de Privacidad periódicamente para cualquier cambio.`
      },
      {
        title: '14. Contáctenos',
        content: `Si tiene alguna pregunta sobre esta Política de Privacidad, contáctenos:

Por correo electrónico: info@ertheo.com

Por correo postal:
ERTHEO LIMITED
SUITE 140 TEMPLE CHAMBERS
3-7 TEMPLE AVENUE
LONDON, ENGLAND EC4Y 0DA`
      }
    ]
  },
  fr: {
    title: 'Politique de Confidentialité',
    lastUpdated: 'Janvier 2023',
    sections: [
      {
        title: '1. Responsable du Traitement',
        content: `Cette Politique de Confidentialité vise à informer les visiteurs de notre site web (www.ertheo.com) et les clients de la Société sur la collecte, l'utilisation et la divulgation des données personnelles lors de l'utilisation de nos services et les options disponibles concernant vos informations.

Le responsable du traitement de vos données est ERTHEO LIMITED, avec le numéro d'entreprise 14272961.

Notre siège social est situé au SUITE 140 TEMPLE CHAMBERS, 3-7 TEMPLE AVENUE, LONDON, ENGLAND EC4Y 0DA.

Adresse e-mail – info@ertheo.com`
      },
      {
        title: '2. Informations que Nous Collectons',
        content: `Nous collectons plusieurs types différents d'informations à diverses fins pour fournir et améliorer notre service.

Données Personnelles:
Lors de l'utilisation de notre service, nous pouvons vous demander de nous fournir certaines informations personnellement identifiables qui peuvent être utilisées pour vous contacter ou vous identifier. Les informations personnellement identifiables peuvent inclure, mais sans s'y limiter:
• Adresse e-mail
• Prénom et nom
• Numéro de téléphone
• Adresse, État, Province, Code Postal, Ville
• Cookies et Données d'Utilisation
• Date de naissance (pour les mineurs participant aux camps)
• Informations médicales (allergies, conditions, médicaments)
• Informations de contact d'urgence
• Informations de passeport/identité à des fins de voyage

Données d'Utilisation:
Nous pouvons également collecter des informations sur la façon dont le service est accédé et utilisé. Ces Données d'Utilisation peuvent inclure des informations telles que l'adresse de Protocole Internet de votre ordinateur (par exemple, adresse IP), le type de navigateur, la version du navigateur, les pages de notre service que vous visitez, l'heure et la date de votre visite, le temps passé sur ces pages, les identifiants uniques d'appareils et d'autres données de diagnostic.

Données de Suivi et Cookies:
Nous utilisons des cookies et des technologies de suivi similaires pour suivre l'activité sur notre service et conserver certaines informations.`
      },
      {
        title: '3. Utilisation des Données',
        content: `La Société utilise les données collectées à diverses fins:

• Fournir et maintenir le service
• Vous notifier des changements apportés à notre service
• Vous permettre de participer aux fonctionnalités interactives de notre service lorsque vous choisissez de le faire
• Fournir un service client et une assistance
• Fournir des analyses ou des informations précieuses afin que nous puissions améliorer le service
• Surveiller l'utilisation du service
• Détecter, prévenir et résoudre les problèmes techniques
• Traiter votre inscription aux camps et programmes
• Communiquer avec vous concernant votre réservation
• Vous envoyer des informations sur nos programmes et services (avec votre consentement)
• Se conformer aux obligations légales`
      },
      {
        title: '4. Base Juridique du Traitement des Données Personnelles',
        content: `Notre base juridique pour la collecte et l'utilisation des informations personnelles décrites dans cette Politique de Confidentialité dépend des Données Personnelles que nous collectons et du contexte spécifique dans lequel nous les collectons.

La Société peut traiter vos Données Personnelles parce que:
• Nous devons exécuter un contrat avec vous (traitement de votre inscription au camp)
• Vous nous avez donné la permission de le faire
• Le traitement est dans nos intérêts légitimes et n'est pas supplanté par vos droits
• Pour se conformer à la loi`
      },
      {
        title: '5. Conservation des Données',
        content: `La Société ne conservera vos Données Personnelles que le temps nécessaire aux fins énoncées dans cette Politique de Confidentialité. Nous conserverons et utiliserons vos Données Personnelles dans la mesure nécessaire pour nous conformer à nos obligations légales, résoudre les litiges et faire appliquer nos accords et politiques juridiques.

La Société conservera également les Données d'Utilisation à des fins d'analyse interne. Les Données d'Utilisation sont généralement conservées pendant une période plus courte, sauf lorsque ces données sont utilisées pour renforcer la sécurité ou pour améliorer la fonctionnalité de notre service, ou que nous sommes légalement tenus de conserver ces données pendant des périodes plus longues.

Après la finalisation d'une réservation ou d'une demande, nous conservons généralement les données personnelles jusqu'à 7 ans à des fins légales et comptables.`
      },
      {
        title: '6. Transfert de Données',
        content: `Vos informations, y compris les Données Personnelles, peuvent être transférées vers — et maintenues sur — des ordinateurs situés en dehors de votre état, province, pays ou autre juridiction gouvernementale où les lois sur la protection des données peuvent différer de celles de votre juridiction.

Si vous êtes situé en dehors du Royaume-Uni et choisissez de nous fournir des informations, veuillez noter que nous transférons les données, y compris les Données Personnelles, vers le Royaume-Uni et les traitons là-bas.

Votre consentement à cette Politique de Confidentialité suivi de votre soumission de ces informations représente votre accord à ce transfert.

La Société prendra toutes les mesures raisonnablement nécessaires pour garantir que vos données sont traitées de manière sécurisée et conformément à cette Politique de Confidentialité.`
      },
      {
        title: '7. Divulgation des Données',
        content: `La Société peut divulguer vos Données Personnelles de bonne foi en croyant qu'une telle action est nécessaire pour:
• Se conformer à une obligation légale
• Protéger et défendre les droits ou la propriété de la Société
• Prévenir ou enquêter sur d'éventuels actes répréhensibles en relation avec le service
• Protéger la sécurité personnelle des utilisateurs du service ou du public
• Se protéger contre la responsabilité légale

Nous pouvons également partager vos données avec:
• Les Organisations Partenaires (écoles, camps, académies sportives) qui fournissent les services que vous avez réservés
• Les processeurs de paiement pour effectuer des transactions
• Les autorités légales et réglementaires lorsque la loi l'exige`
      },
      {
        title: '8. Sécurité des Données',
        content: `La sécurité de vos données est importante pour nous, mais n'oubliez pas qu'aucune méthode de transmission sur Internet, ou méthode de stockage électronique n'est 100% sécurisée. Bien que nous nous efforcions d'utiliser des moyens commercialement acceptables pour protéger vos Données Personnelles, nous ne pouvons garantir leur sécurité absolue.

Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger les données personnelles contre le traitement non autorisé ou illégal, la perte accidentelle, la destruction ou les dommages.

Ces mesures incluent:
• Chiffrement des données en transit (SSL/TLS)
• Serveurs et bases de données sécurisés
• Contrôles d'accès et authentification
• Évaluations de sécurité régulières
• Formation du personnel sur la protection des données`
      },
      {
        title: '9. Vos Droits de Protection des Données en vertu du RGPD',
        content: `Si vous êtes résident de l'Espace Économique Européen (EEE), vous disposez de certains droits en matière de protection des données.

La Société vise à prendre des mesures raisonnables pour vous permettre de corriger, modifier, supprimer ou limiter l'utilisation de vos Données Personnelles.

Vous disposez des droits de protection des données suivants:
• Le droit d'accès – Vous avez le droit de demander des copies de vos données personnelles.
• Le droit de rectification – Vous avez le droit de demander que nous corrigions toute information que vous estimez inexacte ou que nous complétions des informations que vous estimez incomplètes.
• Le droit à l'effacement – Vous avez le droit de demander que nous effacions vos données personnelles, sous certaines conditions.
• Le droit de limiter le traitement – Vous avez le droit de demander que nous limitions le traitement de vos données personnelles, sous certaines conditions.
• Le droit d'opposition au traitement – Vous avez le droit de vous opposer à notre traitement de vos données personnelles, sous certaines conditions.
• Le droit à la portabilité des données – Vous avez le droit de demander que nous transférions les données que nous avons collectées à une autre organisation, ou directement à vous, sous certaines conditions.

Si vous souhaitez savoir quelles Données Personnelles nous détenons à votre sujet et si vous souhaitez qu'elles soient supprimées de nos systèmes, veuillez nous contacter à info@ertheo.com.

Vous avez le droit de déposer une plainte auprès d'une Autorité de Protection des Données concernant notre collecte et notre utilisation de vos Données Personnelles.`
      },
      {
        title: '10. Prestataires de Services',
        content: `Nous pouvons employer des sociétés et des individus tiers pour faciliter notre service ("Prestataires de Services"), pour fournir le service en notre nom, pour effectuer des services liés au service ou pour nous aider à analyser comment notre service est utilisé.

Ces tiers n'ont accès à vos Données Personnelles que pour effectuer ces tâches en notre nom et sont tenus de ne pas les divulguer ni les utiliser à d'autres fins.

Les prestataires de services incluent:
• Fournisseurs d'hébergement web
• Processeurs de paiement
• Fournisseurs de services de messagerie
• Fournisseurs d'analyse
• Organisations Partenaires (camps, écoles, académies)`
      },
      {
        title: '11. Liens vers d\'Autres Sites',
        content: `Notre service peut contenir des liens vers d'autres sites qui ne sont pas exploités par nous. Si vous cliquez sur un lien tiers, vous serez dirigé vers le site de ce tiers. Nous vous conseillons vivement de consulter la Politique de Confidentialité de chaque site que vous visitez.

Nous n'avons aucun contrôle sur et n'assumons aucune responsabilité pour le contenu, les politiques de confidentialité ou les pratiques de sites ou services tiers.`
      },
      {
        title: '12. Confidentialité des Enfants',
        content: `Nos services sont conçus pour être réservés par des parents ou tuteurs au nom de mineurs. Nous ne collectons pas sciemment d'informations personnellement identifiables directement auprès de personnes de moins de 18 ans sans le consentement parental.

Lorsque les parents ou tuteurs inscrivent un mineur à un camp, ils fournissent les informations personnelles du mineur en son nom. Ces informations sont utilisées uniquement dans le but de fournir les services du camp et d'assurer la sécurité et le bien-être du participant.

Si vous êtes parent ou tuteur et que vous savez que votre enfant nous a fourni des Données Personnelles sans votre consentement, veuillez nous contacter.`
      },
      {
        title: '13. Modifications de Cette Politique de Confidentialité',
        content: `Nous pouvons mettre à jour notre Politique de Confidentialité de temps en temps. Nous vous informerons de tout changement en publiant la nouvelle Politique de Confidentialité sur cette page.

Nous vous informerons par e-mail et/ou par un avis visible sur notre service, avant que le changement n'entre en vigueur et nous mettrons à jour la "date d'entrée en vigueur" en haut de cette Politique de Confidentialité.

Il vous est conseillé de consulter cette Politique de Confidentialité périodiquement pour tout changement.`
      },
      {
        title: '14. Nous Contacter',
        content: `Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter:

Par e-mail: info@ertheo.com

Par courrier:
ERTHEO LIMITED
SUITE 140 TEMPLE CHAMBERS
3-7 TEMPLE AVENUE
LONDON, ENGLAND EC4Y 0DA`
      }
    ]
  }
};

const PrivacyPolicyPage = () => {
  const { language } = useLanguage();
  const content = privacyContent[language] || privacyContent.en;

  return (
    <div className="min-h-screen bg-gray-50">
      <NavigationHeader />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            {content.title}
          </h1>
          <p className="text-gray-600 mb-8">
            <strong>{language === 'en' ? 'Last Updated:' : language === 'es' ? 'Última Actualización:' : 'Dernière Mise à Jour:'}</strong> {content.lastUpdated}
          </p>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {content.sections.map((section, index) => (
                <section key={index} className="mb-8">
                  <h2 className="text-xl font-black text-gray-900 mb-4">{section.title}</h2>
                  <div className="text-gray-700 whitespace-pre-line">
                    {section.content}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
